import React from "react";

function Resume(props) {
  const {year, position, graduation, university, company, details} = props.resumeData;

  // const detailList = details.map((d) => <li key={d.id}>{d.detail}</li>);

  return (
    <div className="mi-resume mt-30">
      <div className="mi-resume-summary">
        <h6 className="mi-resume-year">{year}</h6>
      </div>
      <div className="mi-resume-details">
        <h5>{position || graduation}</h5>
        <h6 className="mi-resume-company">{company || university}</h6>
        {Array.isArray(details) ? (
          <p style={{ whiteSpace: "pre-line" }}>{details.join("\n")}</p>
        ) : (
          <p>{details}</p>
        )}
        {/* <ul style={{ listStyleType: "none" }}>{detailList}</ul> */}
      </div>
    </div>
  );
};

export default Resume;
